import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md" }

import { unix } from 'dayjs';


export default /*#__PURE__*/_defineComponent({
  __name: 'TopOpponents',
  props: { topOpponents: Array },
  setup(__props) {

const props = __props



console.log('props', props)

const cashFieldCallback = (amount: any) => {
  var cash = (amount / 100) + "$"
  cash += amount > 0 ? " 🟩" : " 🟥"
  return cash
}

const columns: Array<any> = [
  { name: 'ID', label: 'ID', field: (t: any) => t.UserID, align: 'left' },
  { name: 'DisplayName', label: 'DiplayName', field: (t: any) => t.DisplayName, align: 'left' },
  { name: 'Cash', align: 'left', label: 'Cash 💵', field: (item: any) => cashFieldCallback(item.Cash), sortable: true },
  { name: 'BonusCash', align: 'left', label: 'Bonus Cash 💸', field: (item: any) => cashFieldCallback(item.Cash), sortable: true },
  { name: 'Games', label: 'Games', field: (t: any) => t.Games, align: 'left' },
]

return (_ctx: any,_cache: any) => {
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_table, {
      title: "Top Opponents 🤺",
      rows: props.topOpponents,
      columns: columns,
      "row-key": "name"
    }, null, 8, ["rows"])
  ]))
}
}

})